import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ISearch } from '../models/global-search.model';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private search: BehaviorSubject<ISearch[]> = new BehaviorSubject([]);
  public lastActivity: Date;
  constructor() {}

  addOrEditSearch(search: ISearch): void {
    if (
      this.search
        .getValue()
        .filter(
          storage =>
            storage.name == search.name && storage.module == search.module
        ).length > 0
    ) {
      this.search.next([
        ...this.search
          .getValue()
          .filter(
            storage =>
              storage.name != search.name && storage.module == search.module
          ),
        { ...search }
      ]);
    } else {
      this.search.next([...this.search.getValue(), { ...search }]);
    }
  }

  removeSearch(search: {
    name: string;
    module: 'quote' | 'order' | 'lead';
  }): void {
    this.search.next([
      ...this.search
        .getValue()
        .filter(
          storage =>
            storage.name != search.name && storage.module == search.module
        )
    ]);
  }

  cleanModuleSearch(module: 'quote' | 'order' | 'lead'): void {
    this.search.next([
      ...this.search.getValue().filter(search => search.module != module)
    ]);
  }

  cleanGlobalSearch(): void {
    this.search.next([]);
  }

  listenGlobalSearch(): Observable<any> {
    return this.search;
  }
}
